import React from 'react';
import * as styles from './detailedCurriculum.module.scss';

const LINKS = [
  { href: '#outline', label: 'Outline' },
  { href: '#sprint-1', label: 'Sprint 1' },
  { href: '#sprint-2', label: 'Sprint 2' },
  { href: '#sprint-3', label: 'Sprint 3' },
  { href: '#sprint-4', label: 'Sprint 4' },
  { href: '#sprint-5', label: 'Sprint 5' },
  { href: '#sprint-6', label: 'Sprint 6' },
  { href: '#interview', label: 'Interview sprint' },
  { href: '#ladder', label: 'How they build up' },
  { href: '#quickref', label: 'All projects' },
  { href: '#mini-projects', label: 'Mini projects' },
  { href: '#guided', label: 'Guided projects' },
  { href: '#optbuilds', label: 'Optional builds' },
  { href: '#modules', label: 'Optional modules' },
  { href: '#prework', label: 'Pre-work' },
  { href: '#faq', label: 'FAQ' },
];

const SubNav = () => {
  return (
    <nav className={styles.subnav}>
      <div className={styles.wrap}>
        {LINKS.map((link) => (
          <a href={link.href} key={link.href}>
            {link.label}
          </a>
        ))}
      </div>
    </nav>
  );
};

export default SubNav;
